"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _SidePageSidebar = require("./SidePageSidebar");
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)(function (_theme) {
  return {
    root: {
      flexGrow: 1,
      maxWidth: function maxWidth(_ref) {
        var withSidebar = _ref.withSidebar;
        withSidebar ? "calc(100% - ".concat(_SidePageSidebar.SIDEBAR_WIDTH, "px - 32px)") : "100%";
      },
      height: "100%",
      flexDirection: "column",
      display: "flex",
      minWidth: 0
    }
  };
}, {
  name: "GgSidePageContent"
});
var NewSidePageContent = function NewSidePageContent(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    disableGutters = _ref2.disableGutters,
    _ref2$gutterTop = _ref2.gutterTop,
    gutterTop = _ref2$gutterTop === void 0 ? true : _ref2$gutterTop,
    _ref2$withSidebar = _ref2.withSidebar,
    withSidebar = _ref2$withSidebar === void 0 ? false : _ref2$withSidebar;
  var classes = useStyles({
    disableGutters: disableGutters,
    gutterTop: gutterTop,
    withSidebar: withSidebar
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx["default"])(classes.root, className),
    children: children
  });
};
NewSidePageContent.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].node]),
  className: _propTypes["default"].string,
  loading: _propTypes["default"].bool
};
var _default = exports["default"] = NewSidePageContent;